import { IsString, IsNotEmpty, IsOptional, IsArray } from 'class-validator';
import { Type } from 'class-transformer';

import { SubstituteDto } from '..';

const notEmptyOptions = {
  message: 'Обязательное поле',
  groups: ['form'],
};

type SubstituteType = 'permanent' | 'temporary';

export class CreateSubstituteFormDto {
  @IsString({
    ...notEmptyOptions,
  })
  @IsNotEmpty({
    ...notEmptyOptions,
  })
  typeOfSubstitute: SubstituteType;

  @Type(() => SubstituteDto)
  @IsArray({
    groups: ['form'],
  })
  @IsOptional({
    groups: ['form'],
  })
  substitutions: SubstituteDto[];

  @IsString({
    ...notEmptyOptions,
  })
  @IsNotEmpty({
    ...notEmptyOptions,
  })
  substituteId: string;

  @Type(() => String)
  @IsArray({
    ...notEmptyOptions,
  })
  @IsNotEmpty({
    ...notEmptyOptions,
  })
  eventTypes: string[];
}
